<div class="w-full menu_con">
  <div class="container_width">
    <p-menubar [model]="items" styleClass="menu_top">
      <ng-template pTemplate="start" class="sm:hidden">
        <img src="../../../../assets/images/logo.svg" alt="GradPilots" style="width: 116px; cursor: pointer;" (click)="router.navigate(['/portal/dashboard'])">
      </ng-template>
      <ng-template pTemplate="item" let-item let-root="root">
        <a pRipple class="flex align-items-center p-menuitem-link" [routerLink]="item.routerLink"
          routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <span class="m-0">{{ item.label }}</span>
          <i *ngIf="item.items" [ngClass]="['pi', root ? 'pi-angle-down ml-2' : 'pi-angle-right ml-auto']"></i>
        </a>

      </ng-template>
      <!-- <ng-template pTemplate="item2">
          <p-button label="Toggle" (onClick)="menu.toggle($event)" />
          <p-tieredMenu #menu [model]="items" [popup]="true" />
      </ng-template> -->
      <ng-template pTemplate="end">
        <div class="flex align-items-center gap-2">
          <p-button styleClass="schedule-call-btn" (onClick)="showScheduleCallPopup = true">
            <span class="btn-text">Schedule a call</span>
            <div class="icon-circle">
              <i class="pi pi-arrow-right"></i>
            </div>
          </p-button>
          <div class="card flex align-items-center justify-content-center gap-2">

            <div style="position: relative; display: flex; align-items: center;">
              <p-button (onClick)="op.toggle($event)" styleClass="icon_btn">
                <img src="assets/icons/nav-notification-icon.svg" alt="Notifications" style="width: 28px; height: 28px;">
              </p-button>
              <span *ngIf="unreadNotificationCount > 0" class="notification-badge" style="top: -6px; right: -6px;">{{ unreadNotificationCount }}</span>
            </div>
            <p-overlayPanel #op (onShow)="markAllAsRead()" [style]="{'width': '400px'}">
              <div class="flex flex-column gap-3 w-full max-w-25rem">
                <b class="block w-full text-left font-bold text-xl"
                  style="letter-spacing: -1px; color: #12263F;">Notifications</b>
              </div>
              <app-notification></app-notification>
            </p-overlayPanel>
          </div>
          <div class="card flex align-items-center justify-content-center">
            <p-menu #menu [model]="items1" [popup]="true" appendTo="body" class="w-auto" />
            <p-button (onClick)="menu.toggle($event)" styleClass="user_pill_btn">
              <div class="flex align-items-center gap-2">
                <ng-container *ngIf="user?.profileImageUrl; else defaultProfileIcon">
                  <img [src]="user.profileImageUrl" alt="Profile" style="width: 36px; height: 36px; border-radius: 50%; object-fit: cover;">
                </ng-container>
                <ng-template #defaultProfileIcon>
                  <img src="assets/icons/nav-profile-icon.svg" alt="Profile" style="width: 36px; height: 36px;">
                </ng-template>
                <i class="pi pi-angle-down" style="font-weight: bold; font-size: 0.8rem; margin-right: 4px;"></i>
              </div>
            </p-button>
          </div>
        </div>
      </ng-template>
    </p-menubar>

  </div>
</div>

<!-- Floating Chat Button -->
<div class="floating-chat-container" *ngIf="!isChatPage">
  <p-button styleClass="floating_chat_btn" (onClick)="onChatIconClick()">
    <img src="assets/icons/nav-chat-icon.svg" alt="Chat" style="width: 28px; height: 28px;">
  </p-button>
  <ng-container *ngIf="(chatUnreadCount$ | async) as unreadCount">
    <span *ngIf="unreadCount > 0" class="notification-badge">{{ unreadCount }}</span>
  </ng-container>
</div>

<app-clarity-call-popup [(visible)]="showScheduleCallPopup" [contactPurpose]="10"></app-clarity-call-popup>
